import React, {useState} from 'react';

import CopyBtn from "../CopyBtn/CopyBtn";
import CurlExample from "./CurlExample";
import PHPExample from "./PHPExample";
import PythonExample from "./PythonExample";
import LinkExample from "./LinkExample";

const CodeExample = (props) => {
    const {method, url, data, headers, paramsType, lang, secretKey} = props;
    let [codeText, setCodeText] = useState('');

    const codeTextChangeHandler = () => (codeText) => {
        setCodeText(codeText);
    };

    const customStyle = {
        fontSize: '14px',
        zIndex: 0,
        backgroundColor: 'transparent'
    };

    const properties = {
        method,
        url,
        data,
        headers,
        paramsType,
        changeCodeText: codeTextChangeHandler(),
        customStyle,
        secretKey
    };

    const getCodeExampleComponent = () => {
      switch (lang) {
          case 'php': return <PHPExample {...properties}/>;
          case 'curl': return <CurlExample {...properties}/>
          case 'python': return <PythonExample {...properties}/>
          case 'link': return <LinkExample {...properties}/>
      }
    };

    return (

        <div className="code-example">
            <div className="copy-btn-outer">
                <CopyBtn text={codeText}></CopyBtn>
            </div>
            <div className="code-example__code">
                {getCodeExampleComponent()}
            </div>
        </div>
    );
}


export default CodeExample;